export default {
    data() {
        return {
            models: []
        }
    },

    methods: {
        addModel(model) {
            this.models.push(model)
        },

        findModelByTable(table) {
            return this.models.find(model => model.table == table)
        },

        findModelByName(name) {
            return this.models.find(model => model.name == name)
        },

        findModelByClass(class_name) {
            return this.models.find(model => model.class == class_name)
        }
    }
}